import React, { useState, useEffect,useRef } from 'react';
import {Main,Loading,Axios} from '../../../Helpers/importacionesComunes'
import {useContextoGlobal} from '../../../Context/contextoGlobal';
import {Tabla} from '../componentes/Tabla'
import {Cabecera} from '../componentes/Cabecera'
import {
    Spinner, Typography, Button, Drawer
} from "@material-tailwind/react";
import AbmObrero from '../../../abms/Abm-obrero';
import ExportToExcelCredencial from '../../../componentes/exportExcelCredencial';
import { TrashIcon, IdentificationIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { SearchResultsCounter } from '../../ComponentesComunes/SearchResultsCounter';
import { getRegionBadgeStyle, getRangoBadgeStyle } from '../../ComponentesComunes/identificadoresVisuales';
import Swal from 'sweetalert2';

export default function Ministros({match,history}){
    const [registros,setRegistros] = useState([])
    const [registrosAmostrar,setRegistrosAmostrar]=useState([])
    const [cargandoRegistros,setCargandoRegistros] = useState(true);
    const {usuario,mostrarCredenciales,setMostrarCredeciales,credenciales,setCredenciales} = useContextoGlobal();
    const [hayFiltrosActivos,setHayFiltrosActivos]=useState(false)
    const [huboError,setHuboError]=useState(false)
    const [periodosFiscales,setPeriodosFiscales]=useState([])
    const [periodoSeleccionado,setPeriodoSeleccionado]=useState(0)
    const [obreroSeleccionado,setObreroSeleccionado] = useState(null)
    const [isObreroSeleccionado,setIsObreroSeleccionado]=useState(false)
    const [registrosActivos,setRegistrosActivos] = useState(true)
    const filtrosRef = useRef()

useEffect(()=>{

    if (usuario){
        buscarDatos({conLoading:true}) 
    } 
            
},[usuario,registrosActivos]) // agregué usuario porque necesito que se dispare el evento cuando no sea vacío usuario, al principio es vacío por unos milisegundos...
    
   useEffect(()=>{

        if (registrosAmostrar.length != registros.length){
            setHayFiltrosActivos(true)
        }else{
            setHayFiltrosActivos(false)
        }

    },[registrosAmostrar])

const buscarDatos = async (params={})=>{
    
    const {conLoading} = params // con loading se usa para la búsqueda inicial de datos
                                // Cuando se modificó un ministro queremos mantener el modal abierto y no mostramos el loading

    let url = buscarApi(usuario,registrosActivos);
    setHuboError(false)
    setRegistros([]) 
    conLoading &&  setCargandoRegistros(true)
    try{          
        const {data} = await Axios.get(`${url}`)
        if(usuario.perfil=='distrito'){
            setRegistros(data.filter(item=>item.id_distrito==usuario.id_distrito))
        }else{
            setRegistros(data)
        }
        conLoading && setCargandoRegistros(false)
    }catch(err){
        console.log(err)    
        setHuboError(true)
        conLoading && setCargandoRegistros(false)
    }
}

function finalizarAltaOcopiaMinistro (alta,id){
    finalizarObreroSeleccionado()
    buscarDatos()
}

function finalizarObreroSeleccionado (){
    setIsObreroSeleccionado(false);
    setObreroSeleccionado(null);
}

const resetearLista = (params={})=>{
    const {respetarFiltros} = params

    if(respetarFiltros && filtrosRef.current){

        const filtros = filtrosRef.current;
        const datosFiltrados = registros.filter(filtros)
        setRegistrosAmostrar(datosFiltrados)

    }else{
        filtrosRef.current = {}
        setRegistrosAmostrar(registros)
    }
   
}

const filtrarLista=(filterCallback)=>{

    let vectorRegistrosOriginalfiltrado;

    vectorRegistrosOriginalfiltrado = registros.filter(filterCallback) 

    filtrosRef.current = filterCallback

    setRegistrosAmostrar(vectorRegistrosOriginalfiltrado)

}

const eliminarCredencial = (id_obrero)=>{
    setCredenciales(credenciales.filter(item=>item.id_obrero!=id_obrero))
}


const eliminarCredenciales = ()=>{

         Swal.fire({
                    html: `<div><p class="mb-2 mt-2">¿Desea eliminar todas las credenciales?</p></div>`,
                    showCancelButton: true,
                    confirmButtonText: 'Eliminar',
                    cancelButtonText: 'Cancelar'
                }).then(resultado => {
                        if (resultado.value) {
                               setCredenciales([])
                        }
                })
}


if (huboError){
    return <Main center>
                <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                    <span>Se produjo un error al cargar los datos para esta vista</span>
                </div>
            </Main>
}

if (cargandoRegistros || registros.length==0 || !usuario){
    return (
        <Main center alinear>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando registros...</span>
            </div>
        </Main>
    )
};

return (
        <div className='flex w-full'> 
            {isObreroSeleccionado && (
                <div className='w-full flex flex-col justify-center items-center lg:!m-6 xl:!m-6'> 
                    <AbmObrero 
                        id_obrero={obreroSeleccionado ? obreroSeleccionado : null} 
                        esModal={true}
                        usuario={usuario} 
                        finalizarAltaOcopia={finalizarAltaOcopiaMinistro}
                        finalizarObreroSeleccionado={finalizarObreroSeleccionado}
                    />
                </div>
            )}

            <div 
                style={{display: isObreroSeleccionado ? 'none' : ''}} 
                className="w-full bg-blue lg:!m-6 xl:!m-6 items-center flex flex-col justify-center"
            >
                <div className="hidden lg:flex xl:flex flex-col mb-2 items-center text-center w-full">
                    <h1 className="text-2xl font-bold text-gray-800">Directorio de Ministros</h1>
                </div>
                <Typography variant="h5" className="w-full mb-2 flex justify-center lg:hidden xl:hidden">
                    Ministros
                </Typography> 

                <div className='mb-2 w-full px-4 lg:px-0'>
                    <Cabecera
                        periodosFiscales={periodosFiscales}
                        periodoSeleccionado={periodoSeleccionado}
                        filtrarLista={filtrarLista}
                        hayFiltrosActivos={hayFiltrosActivos}  
                        registrosActivos={registrosActivos}
                        setRegistrosActivos={setRegistrosActivos}
                        buscarDatos={buscarDatos}
                        resetearLista={resetearLista}
                        tablasDelListado={tablasDelListado(registros)}                           
                    />
                </div>
                <Credenciales   abrir={mostrarCredenciales} 
                                setMostrarCredeciales={setMostrarCredeciales} 
                                credenciales={credenciales} 
                                eliminar={eliminarCredencial}
                                eliminarCredenciales={eliminarCredenciales}/>
                <SearchResultsCounter
                    count={registrosAmostrar.length}
                    singularLabel="ministro"
                    pluralLabel="ministros"
                    badgeLabel="Ministros"
                />
                {registrosAmostrar.length ? (
                    <Tabla  
                        registrosAmostrar={registrosAmostrar} 
                        reinicializar={finalizarAltaOcopiaMinistro}
                        resetearLista={resetearLista}
                        obreroSeleccionado={obreroSeleccionado}
                        setObreroSeleccionado={setObreroSeleccionado}
                        setIsObreroSeleccionado={setIsObreroSeleccionado}
                        // credenciales={credenciales}
                        // setcredenciales={setCredenciales}
                    />
                ) : null}
            </div>
        </div>
    );
}

function buscarApi(usuario,registrosActivos){
    return usuario.sede_admin ? `/api/tablasgenerales/obreros/*/${registrosActivos ? 1 : 0}` : `/api/tablasgenerales/obreros/${usuario.id_region}/${registrosActivos ? 1 : 0}`
}


const tablasDelListado = (listado)=>{

    const ministerios = ministeriosDeLosObreros(listado)

    const estados_credenciales_ministros = estadosCredencialDeLosObreros(listado)

    return {ministerios:ministerios, estadosCredenciales:estados_credenciales_ministros}
}

const ministeriosDeLosObreros = (listado)=>{
   

        const ministerios = listado.map(item=>item.ministerio.replace(/\[/g, " ").replace(/\]/g, " ")).sort().filter((item,index,vector)=>
        item != vector[index-1])

        const ministerios_filtrados = ministerios.toString().split(" ").sort().filter((item,index,vector)=>
        item != vector[index-1] && item!="" && item!=",").map(item=>`[${item}]`)

        return ministerios_filtrados
}

const estadosCredencialDeLosObreros = (listado)=>{

    return listado.map(item=>item.tieneCredencial).sort().filter((item,index,vector)=>
    item != vector[index-1] )
}

const Credenciales = ({ 
  credenciales, 
    abrir, 
  eliminar, 
  eliminarCredenciales, 
    setMostrarCredeciales
}) => {
    const badgeClassName = "rounded-full px-2.5 py-1 text-xs font-semibold tracking-wide shadow-sm";
  const datosExcel = credenciales.map(i => ({
    iniciales: i.rango_corto,
    rango: i.rango_largo,
    nombre: i.nombre_obrero,
    id_region: i.id_region,
    nro_documento: i.nro_documento
  }));

  return (
        <Drawer open={abrir} onClose={() => setMostrarCredeciales(false)} placement="right" className="!w-full md:!w-[46rem] p-0 overflow-y-auto">
            <div className="flex min-h-full flex-col bg-white">
                <div className="sticky top-0 z-10 border-b border-slate-100 bg-white px-4 pt-4 pb-2 shadow-sm">
                    <div className="flex items-start justify-between mb-2">
                        <h2 className="flex items-center gap-2 text-xl font-bold text-slate-900">
                            <IdentificationIcon className="h-6 w-6 text-sky-600" />
                            Generación de credenciales
                        </h2>
                        <Button
                            variant="text"
                            className="min-w-fit rounded-full border border-slate-200 bg-white p-2 text-slate-500 shadow-sm hover:bg-slate-50"
                            onClick={() => setMostrarCredeciales(false)}
                            title="Cerrar panel"
                        >
                            <XMarkIcon className="h-5 w-5" />
                        </Button>
                    </div>
                    <div className="mb-2 flex items-center">
                        <div className="rounded-lg border border-sky-100 bg-sky-50 px-3 py-1 text-center">
                            <span className="text-xs font-medium uppercase tracking-widest text-sky-600">Seleccionados</span>
                            <span className="ml-2 text-lg font-bold text-slate-900 align-middle">{credenciales.length}</span>
                        </div>
                    </div>
                    <p className="mb-2 text-sm text-slate-600">
                        Seleccioná ministros desde la grilla y armá el listado final sin salir del directorio.
                    </p>
                    <div className="flex flex-col gap-3 md:flex-row md:flex-wrap md:items-center mt-2">
                        <Button
                            variant="outlined"
                            className="w-full justify-center rounded-xl border-slate-300 bg-white px-4 py-3 text-sm font-semibold normal-case text-slate-700 shadow-sm md:w-auto"
                            onClick={() => setMostrarCredeciales(false)}
                        >
                            Cancelar
                        </Button>

                        {!!credenciales.length && (
                            <div className="w-full md:w-auto">
                                <ExportToExcelCredencial 
                                    titulo="Generar Excel Impresiones" 
                                    data={datosExcel}
                                />
                            </div>
                        )}

                        {!!credenciales.length && (
                            <Button 
                                color="red"
                                variant="outlined"
                                className="flex w-full items-center justify-center gap-2 rounded-xl border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-500 shadow-sm md:w-auto"
                                onClick={eliminarCredenciales}
                            >
                                <TrashIcon className="h-5 w-5"/> 
                                Borrar todo el listado
                            </Button>
                        )}
                    </div>
                </div>

                <div className="flex-1 p-4">
                    {credenciales?.length ? (
                        <div className="rounded-3xl border border-slate-200 bg-white p-3 shadow-sm">
                            <div className="mb-3 px-2 pt-1">
                                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Ministros incluidos</p>
                            </div>
                            <div className="space-y-3">
                                {credenciales.map((item) => (
                                    <div
                                        key={item.id_obrero_acta || item.id_obrero}
                                        className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-gradient-to-r from-slate-50 to-blue-50/40 px-3 py-3 shadow-sm transition-colors hover:border-blue-100 hover:from-blue-50 hover:to-white"
                                    >
                                        <Foto id_obrero={item.id_obrero} dni={item.nro_documento} compacta={true} />

                                        <div className="min-w-0 flex-1">
                                            <p className="truncate text-sm font-semibold text-slate-900 md:text-[15px]">
                                                {item.nombre_obrero}
                                            </p>
                                            <div className="mt-1 flex flex-wrap items-center gap-2">
                                                <span className={badgeClassName} style={getRegionBadgeStyle(item.id_region)}>
                                                    Región {item.id_region}
                                                </span>
                                                <span className={badgeClassName} style={getRangoBadgeStyle(item.rango)}>
                                                    {item.rango}
                                                </span>
                                            </div>
                                        </div>

                                        <Button
                                            size="sm"
                                            variant="text"
                                            color="red"
                                            title="Quitar del listado"
                                            className="min-w-fit rounded-full p-2 text-red-400 hover:bg-red-50"
                                            onClick={() => eliminar(item.id_obrero)}
                                        >
                                            <XMarkIcon className="h-5 w-5" />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="w-full rounded-lg border border-dashed border-amber-300 bg-amber-50 px-6 py-10 text-center text-amber-900">
                            <p className="text-lg font-semibold">No hay credenciales seleccionadas.</p>
                            <p className="mt-2 text-sm">
                                Use el ícono de credenciales en la columna Acciones para armar el listado mientras este panel esté abierto.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </Drawer>
  );
};

const Foto = ({ id_obrero, dni, compacta = false }) => {
    const [datos, setDatos] = useState([]);
    const [buscandoDatos, setBuscandoDatos] = useState(false);

    useEffect(() => {
        const obtenerDatos = async () => {
            setBuscandoDatos(true);
            try {
                const { data } = await Axios.get(`/api/tablasgenerales/foto/${id_obrero}`);
                setDatos(data);
                setBuscandoDatos(false);
            } catch (err) {
                console.log(err);
                setBuscandoDatos(false);
            }
        };
        obtenerDatos();
    }, [id_obrero]);

    const wrapperClassName = compacta
        ? 'flex shrink-0 justify-center items-center'
        : 'flex justify-center items-center w-full'

    if (buscandoDatos) {
        return <div className={wrapperClassName}><Spinner className={compacta ? "h-5 w-5" : "h-4 w-4"} /></div>;
    }

    if (!datos || datos.length === 0) {
        return (
            <div className={wrapperClassName}>
                <div className={`${compacta ? 'h-14 w-14 shrink-0' : 'h-12 w-12'} overflow-hidden rounded-full border border-gray-200 bg-gray-50`}>
                    <img className="h-full w-full object-cover opacity-50" src='images/user-circle.svg' alt="Sin foto" />
                </div>
            </div>
        );
    }

    const imageSource = `data:image/jpeg;base64,${datos}`;

   return (
    <div className={wrapperClassName}> 
        <a 
            href={imageSource} 
            download={`${dni}.jpg`} 
            title="Clic para descargar foto"
            className="cursor-pointer"
        >
            <div className={`${compacta ? 'h-14 w-14 shrink-0' : 'h-10 w-10 mx-auto'} overflow-hidden rounded-full border border-gray-200 shadow-sm hover:ring-2 hover:ring-blue-400 transition-all active:scale-95`}>
                <img 
                    className="h-full w-full object-cover" 
                    src={imageSource} 
                    alt="Foto miniatura"
                />
            </div>
        </a>
    </div>);
};